import styled from 'styled-components';
import AnnouncenentCard from './components/AnnouncenentCard';
import CommonTable from '../../components/ReportTable';
import ProjectCommonTable from '../../components/ProjectTable';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getIndexData } from '../../api/Home';
import { message } from 'antd';
import { HotProjectsIcon, NewPullRequestIcon, NewSubmitIcon, NewPublic } from '../../icons';
import ListBG from '../../assets/images/report-list-bg.png';

const HomeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  max-width: 1200px;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const MainContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

const ProjectContainer = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const ReportContainer = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const ProjectItem = styled.div`
  width: 100%;
  margin-bottom: 24px;
  border-radius: 6px;
  padding: 0 24px;
  background-color: #0e0e0e;
  background-image: url(${ListBG});
  background-repeat: no-repeat;
`;

const ReportItem = styled.div`
  width: 100%;
  margin-bottom: 24px;
  border-radius: 6px;
  padding: 0 24px;
  background-color: #0e0e0e;
  background-image: url(${ListBG});
  background-repeat: no-repeat;
`;

const Home = () => {
  // 定义多语言hooks
  const { t } = useTranslation();

  // 定义变量
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 初始化数据
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data } = await getIndexData();
        
        // for (let i = 0; i < data.length; i++) {
        //   data[i].key = i;
        // }
        setTableData(data);
        // for (let i = 0; i < data.articles.length; i++) {
        //   data.articles[i].key = i;
        // }
        // console.log(data.articles);
        // setArticlesData(data.articles);
      } catch (_error) {
        console.log(error);
        setError(_error);
        message.error(error);
        setLoading(false);
      }
      setLoading(false);
    };

    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <HomeContainer>
        <MainContainer>
          <ProjectContainer>
          <ProjectItem>
            <ProjectCommonTable
              data={tableData.hot_projects}
              loading={loading}
              title={
                <>
                  <HotProjectsIcon />
                  {t('projectsTable.homeHotProjectsTitle')}
                </>
              }
              pagination={false}
            />
            </ProjectItem>
        </ProjectContainer>
          <ProjectContainer>
            <ProjectItem>
              <ProjectCommonTable
                data={tableData.latest_projects}
                loading={loading}
                title={
                  <>
                    <NewPublic />
                    {t('projectsTable.homeLatestProjectsTitle')}
                  </>
                }
                pagination={false}
              />
              </ProjectItem>
          </ProjectContainer>
          <ReportContainer>
            <ReportItem>
              <CommonTable
                data={tableData.approved_reports}
                loading={loading}
                title={
                  <>
                    <NewPullRequestIcon />
                    {t('commonTitle.latestReports')}
                  </>
                }
                pagination={false}
              />
            </ReportItem>
          </ReportContainer>
        </MainContainer>
        
          {/* <AnnouncenentCard data={articlesData} loading={loading} /> */}
      </HomeContainer>
    </>
  );
};

export default Home;
